 <!-- <div style="    height: 5.5%;
    width: 100%;
    background: #f8f8f8;
    position: absolute;
    z-index: 100;
    margin-top: 3.57%;">
 <div class="toolbar-scroll" >
 <button mat-icon-button [matMenuTriggerFor]="appsMenu" style="width: fit-content;
    height: fit-content;
    border-radius: unset;
    margin-right: 10px;margin-left: 10px;">
  <mat-icon style="font-size: 25px;">apps</mat-icon>
  <span style="    margin-left: 2px;
    font-size: 1rem;
    color: #1d1d1d;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: normal;">{{selectedTopNavItem.label}}</span>
</button>
<div role="separator" class="tabcollection-separator" style="border-right: 2px solid #ccc;
    height: 20px;
    margin-right: 10px;"></div>
<mat-menu #appsMenu="matMenu" class="apps-menu-panel">
  <ul class="apps-list">
    <li *ngFor="let item of topNavItems" (click)="selectTopNavItem(item)">
      <mat-icon>{{ item.icon }}</mat-icon>
      <span>{{ item.label }}</span>
    </li>
  </ul>
</mat-menu>
          <ng-container *ngFor="let subItem of (selectedTopNavItem?.subToolbarItems || [])">
             <button
                mat-button
                class="nav-item"
                [ngClass]="{ active: currentSection === subItem.section }"
                (click)="handleNavClick(subItem)"
              >
                <mat-icon>{{ subItem.icon }}</mat-icon>
                <span>{{ subItem.label }}</span>
              </button>
          </ng-container>
        </div>
        </div> -->

<div >
  <div class="label-bar">
     <label i18n="@@spmsUserReg" class="textColour" style="font-size: 18px;
    font-weight: 500;">Alert Rule & Product Mapping</label>
     <span class="example-spacer"></span>
       <app-common-button
          title="Download"
          icon="fas fa-download"
          [buttonId]="1111"
          [variant]="'cancel'"
          width="100%"
          padding="0rem 1rem"
          fontSize=".85rem"
          height="25px"
          (clicked)="exportData()"
          style="margin-right:1%"
          > 
      </app-common-button>
       <app-common-button
           
          title="Refresh"
          icon="fas fa-sync-alt"
          [buttonId]="1111"
          [variant]="'cancel'"
          width="100%"
          padding="0rem 1rem"
          fontSize=".85rem"
          height="25px"
          (clicked)="onRefresh()"
          style="margin-right:1%"
          >
      </app-common-button>
  </div>
    <!-- <div class="summary-card">
    
    <p class="label">Total Products</p>
     <span class="example-spacer"></span>
    <h2 class="value">350</h2>
    </div>
    <div class="counts-bar"> 
    <p class="count-label">Total Alerts</p>
     <span class="example-spacer"></span>
    <h2 class="count-text">350</h2>
    </div>
    <div class="counts-bar">
    <p class="count-label">Active Alerts</p>
     <span class="example-spacer"></span>
    <h2 class="count-text">350</h2>
    </div>
    <div class="counts-bar">
    <p class="count-label">Mapped Products</p>
     <span class="example-spacer"></span>
    <h2 class="count-text">350</h2>
    </div>
    <div class="counts-bar">
    <p class="count-label">UnMapped Products</p>
     <span class="example-spacer"></span>
    <h2 class="count-text">350</h2>
    </div>
    <div class="counts-bar">
    <p class="count-label">Default</p>
     <span class="example-spacer"></span>
    <h2 class="count-text">350</h2>
    </div> -->
    <div class="summary-row">
  <div class="summary-card">
    <span class="label">Total Products</span>
    <span class="value">{{totalProducts}}</span>
  </div>

  <div class="summary-card">
    <span class="label">Total Alert Rules</span>
    <span class="value">{{totalAlerts}}</span>
  </div>

  <div class="summary-card">
    <span class="label">Active Alert Rules</span>
    <span class="value">{{activeAlerts}}</span>
  </div>

  <div class="summary-card">
    <span class="label">Mapped Products </span>
    <span class="value">{{mappedProducts}}</span>
  </div>
  <div class="summary-card">
    <span class="label">UnMapped Products</span>
    <span class="value">{{unmappedProducts}}</span>
  </div>
  <div class="summary-card">
    <span class="label">Default</span>
    <span class="value">{{defaultCount}}</span>
  </div>

  </div>
  <div style="width: 100%;margin-bottom: 5%;">
    <div style="margin-top: 1.5%;display: flex;gap: 1%;">
       <!-- <div class="search-box">
      <i class="pi pi-search"></i>
      <input
        type="text"
        placeholder="Search by product, rule, type..."
        (input)="onSearch($event)"
        #searchInput
      />
      <button 
        *ngIf="searchInput.value" 
        class="clear-search"
        (click)="clearSearch(searchInput)"
      >
        ×
      </button>
    </div> -->
    <p-select
      [options]="productOptions"
        optionLabel="name"
        optionValue="id"
      placeholder="Product"
      [(ngModel)]="selectedProductId"
       [filter]="true"
       [showClear]="true"
        panelStyleClass="custom-pselect-panel"
         appendTo="body"
      class="filter-dd"
      (onChange)="onProductFilter($event.value)">
    </p-select>
     <p-select
      [options]="alertOptions"
      placeholder="Alert Rules"
      optionLabel="ruleName"
      optionValue="id"
      [filter]="true"
      [showClear]="true"
       panelStyleClass="custom-pselect-panel"
         appendTo="body"
      [(ngModel)]="selectedAlertId"
      class="filter-dd"
      (onChange)="onAlertFilter($event.value)">
    </p-select>
     <p-select
      [options]="dataSourceOptions"
      optionLabel="label"
      placeholder="Data Source"
       panelStyleClass="custom-pselect-panel"
         appendTo="body"
      class="filter-dd"
      [filter]="true"
      [showClear]="true"
      [(ngModel)]="selectedSource"
      (onChange)="onDataSourceFilter($event.value)">
    </p-select>
     <span style="display: inline-flex;
    align-items: end;">
    <mat-checkbox  formControlName="isCheckboxSelected" [(ngModel)]="showUnMappedProducts" style="margin-right:1%" class="unMappedProductsCheckBox mat-checkbox-layout" (change)="onShowUnmappedProducts($event)">
      Show Unmapped Products
    </mat-checkbox>
    </span>

<!-- <span class="example-spacer"></span> -->
    </div>

    <ag-grid-angular
      style="margin-top: 2%;height: 55vh;"
      class="ag-theme-balham"
      [rowData]="rowData"
      [components]="components"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [rowSelection]="'multiple'"
      [suppressRowClickSelection]="true"
      [animateRows]="true"
      [paginationPageSize]="50"
      (gridReady)="onGridReady($event)"
      (selectionChanged)="onSelectionChanged($event)"
     [rowHeight]="35"
      [headerHeight]="35"
      [enableBrowserTooltips]="true"
      [floatingFiltersHeight]="45"
      [pagination]="true"
       [suppressPaginationPanel]="true">
    </ag-grid-angular>
    <div class="custom-pagination">
  <span class="range-text">
    {{ startRow }} to {{ endRow }} of {{ totalRows }}
  </span>

  <!-- <button (click)="goToFirst()" [disabled]="currentPage === 1">
     
  </button> -->
  <em class="fas fa-angle-double-left waves-effect waves-light" (click)="goToFirst()"></em>
  <em class="fas fa-angle-left waves-effect waves-light"
                                    (click)="goToPrevious()"></em>
  <!-- <button (click)="goToPrevious()" [disabled]="currentPage === 1">‹</button> -->

  <span class="page-text">
    Page {{ currentPage }} of {{ totalPages }}
  </span>
<em class="fas fa-angle-right waves-effect waves-light" (click)="goToNext()"></em>
<em class="fas fa-angle-double-right waves-effect waves-light" (click)="goToLast()"></em>
  <!-- <button (click)="goToNext()" [disabled]="currentPage === totalPages">›</button>
  <button (click)="goToLast()" [disabled]="currentPage === totalPages">»</button> -->
</div>

  </div>
  <div class="bulk-action-bar" *ngIf="getSelectedCount() > 0">
  <div class="bulk-action-content">

    <!-- Close -->
    <button
      class="icon-btn"
      aria-label="Close selection bar"
      (click)="clearSelection()">
      ✖
    </button>

    <!-- Count -->
    <span class="selection-count">
      <i class="pi pi-check-circle"></i>
      {{ getSelectedCount() }} Items Selected
    </span>

    <div class="divider"></div>

    <!-- Actions -->
         <!-- If Auto Selected Show Message -->
    <ng-container *ngIf="hasAutoSelected(); else allowMapping">
        <span class="action-btn">
       Auto-mapped products cannot be manually mapped.
      </span>

    <button class="action-btn" (click)="clearSelection()">
      <i class="pi pi-times"></i> Clear
    </button>

    <!-- <button class="action-btn" (click)="onMapSelected()">
      <i class="pi pi-link"></i> Map Selected
    </button> -->
    </ng-container>

    <!-- Normal Mapping -->
    <ng-template #allowMapping>
      <!-- MIXED SELECTION BLOCK -->
  <ng-container *ngIf="isMixedSelection(); else singleTypeBlock">

    <span class="action-btn">
     Select only one mapping type at a time.
    </span>

    <button class="action-btn" (click)="clearSelection()">
      <i class="pi pi-times"></i> Clear
    </button>

  </ng-container>


  <!-- SINGLE TYPE BLOCK -->
  <ng-template #singleTypeBlock>

    <button class="action-btn" (click)="clearSelection()">
      <i class="pi pi-times"></i> Clear
    </button>

    <!-- Only NOT_MAPPED -->
    <button
      *ngIf="hasNotMappedSelected()"
      class="action-btn"
      (click)="onMapSelected()">
      <i class="pi pi-link"></i> Map Selected
    </button>

    <!-- Only MANUAL -->
    <button
      *ngIf="hasManualSelected()"
      class="action-btn"
      (click)="onUnmapSelected()">
      <i class="pi pi-link-slash"></i> Unmap Selected
    </button>

  </ng-template>
    </ng-template>

    <!-- <button class="action-btn" (click)="onEditSelected()">
      <i class="pi pi-pencil"></i> Edit Selected
    </button>

    <button class="action-btn" (click)="onDeleteSelected()">
      <i class="pi pi-trash"></i> Delete Selected
    </button> -->

  </div>
</div>

</div>
